<template>
  <div id="assetManagement">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            資產管理
          </div>
          <div class="tip">
            可在此查詢、編輯、管理資產、耗材
          </div>
        </div>
      </div>
      <el-tabs
        id="AssetTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane
          v-for="tab in tabList"
          :key="tab.name"
          :name="tab.name"
        >
          <span slot="label">{{ tab.label }}</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const tabList = [
      {
        name: 'assetList',
        label: '資產設備列表'
      },
      {
        name: 'consumableList',
        label: '耗材列表'
      },
      {
        name: 'maintenance',
        label: '維養計畫'
      }
    ]
    return {
      activeName: this.$route.name,
      tabList
    }
  },
  watch: {
    $route (to, from) {
      const name = this.$route.name
      if (this.tabList.find((el) => el.name === name)) {
        this.activeName = name
      }
    }
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    },
    onScroll () {
      this.$refs.view.autoShow
    }
  }
}
</script>

<style lang="sass" scoped>
#assetManagement
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .introduction
        color: $mainColorDark
        font-size: 20px
        font-weight: initial
        margin: 0 10px
        text-decoration: underline
        cursor: pointer
        &:before
          content: '('
          color: #000
        &:after
          content: ')'
          color: #000
      .questionnaire
        background-color: $bgDark3
        padding: 5px 8px
        span
          color: $mainColor
          cursor: pointer
          margin: 0 10px 0 13px
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 10px 0
#AssetTab
  text-align: center
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
